import { render, staticRenderFns } from "./product.vue?vue&type=template&id=6db3b691&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports